module.exports = __webpack_public_path__ + "files/d277197dc74533f254fc7cb4087463c6.png";